import { showErrorMessage } from 'common/AlertContainer';
import CommonLoader from 'common/CommonLoader';
import marker_icon from 'assets/images/svgs/marker-line-icon.svg';
import radio_tick from 'assets/images/radio-tick.png';
import { Field, useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { InstitutionServices } from 'utils/InstitutionServices';
import { PractitionerService } from 'utils/PractitionerService';
import { isInstitutionAdmin, isPractitioner } from 'utils/UserHelper';
import { createImageFromInitials, getRandomColor, makeFullNameWithAddress, makeFullNameWithAddressWhenAddressIsNested } from 'utils/Utils';
import { encrypt } from 'utils/EncryptDecrypt';

const JobHospitalEditModalForPractitionerUser = (props) => {
    const { modal, setModal } = props;
    const currentUser = useSelector((state) => state.auth.currentUser);
    const [hospitalList, setHospitalList] = useState([]);
    const isPractitionerUser = useMemo(() => isPractitioner(), []);
    const isInstitutionAdminUser = useMemo(() => isInstitutionAdmin(), []);
    const [loadingInstitutions, setLoadingInstitutions] = useState(true);
    const [selectedInstitution, setSelectedInstitution] = useState(null);
    const { values, setFieldValue } = useFormikContext();

    const handleInstitutionSelect = (institutionId) => {
        setSelectedInstitution(institutionId);
    };

    const getHospitalList = () => {
        if (isPractitionerUser)
            PractitionerService.listExperiences(currentUser?.guid)
                .then((response) => {
                    if (response.status === 200) {
                        const seenInstitutions = new Set();
                        const hospitalList = [...response.data]
                            .map((node) => {
                                return {
                                    ...node,
                                    institutionName: makeFullNameWithAddressWhenAddressIsNested(node?.institutionDetail),
                                    name: node?.institutionDetail?.name,
                                    avatarId: node?.institutionDetail?.avatarId,
                                    institutionId: node?.institutionDetail?.guid,
                                };
                            })
                            .filter((nodeItem) => nodeItem?.presentlyWorking)
                            .filter((nodeItem) => {
                                if (seenInstitutions.has(nodeItem.institutionId)) {
                                    return false;
                                } else {
                                    seenInstitutions.add(nodeItem.institutionId);
                                    return true;
                                }
                            });

                        setHospitalList(hospitalList);
                        setLoadingInstitutions(false);
                    }
                })
                .catch((err) => {
                    console.log(err.message);
                    showErrorMessage(err.message);
                });


        if (isInstitutionAdminUser) {
            const insts = currentUser.groups;

            const promises = insts.map(instId => InstitutionServices.getInstitutionById(instId));

            Promise.all(promises)
                .then((responses) => {
                    const hospitalList = responses
                        .filter(response => response.status === 200)
                        .map(response => {
                            const node = response.data;
                            return {
                                ...node,
                                institutionName: makeFullNameWithAddress(node),
                                name: node?.name,
                                avatarId: node?.avatarId,
                                institutionId: node?.guid,
                            };
                        });
                    setLoadingInstitutions(false);
                    setHospitalList(hospitalList);
                })
                .catch((err) => {
                    console.log(err.message);
                    showErrorMessage(err.message);
                });
        }
    }

    useEffect(() => {
        getHospitalList();
    }, []);

    const handleSubmit = () => {
        setFieldValue('institutionDetail', selectedInstitution);
        setModal(false);
    }
    return (
        <Modal isOpen={modal} toggle={() => setModal(!modal)} className="nex-model-v2 modal-dialog-scrollable modal-dialog-centered">
            <ModalHeader toggle={() => setModal(!modal)}>Edit mode</ModalHeader>
            <ModalBody>
                <div className="form-group">
                    {/* <label className='nex-text-lg'>Select hospital you want to go</label> */}
                </div>
                <div className="form-group">
                    <label className='nex-text-lg'>Select hospital you want to go with</label>
                    {loadingInstitutions ?
                        <div className="loading-spiner text-center m-5">
                            <CommonLoader style={{ width: "2rem", height: "2rem" }} />
                        </div>
                        :
                        <div className='nex-radio-hospital--w'>
                            {hospitalList.map((e) => (
                                <div
                                    key={e.institutionId}
                                    className={`nex-radio-hospital ${selectedInstitution === e.institutionId ? 'active' : ''}`}
                                    onClick={() => handleInstitutionSelect(e.institutionId)}
                                >
                                    <div className="nex-custom-radio-v2">
                                        <Field type="radio" name="institutionDetail" value={e.institutionId} className="stratch-link" />
                                        <div className="radio-icon">
                                            <div className="highlited">
                                                <img src={radio_tick} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="graphic">
                                        {e.avatarId ? (
                                            <img
                                                src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${e.institutionId}/${e.avatarId}`}
                                                className="nex-avatar lg"
                                                alt="#"
                                            />
                                        ) : (
                                            <img
                                                src={createImageFromInitials(
                                                    50,
                                                    `${e.name}`,
                                                    getRandomColor(encrypt(e?.institutionId).toString())
                                                )}
                                                className="nex-avatar lg"
                                                alt="#"
                                            />
                                        )}
                                    </div>
                                    <div className="info">
                                        <h3 className='nex-text-xl'>{e.institutionName}</h3>
                                        <p>
                                            <span className='icon'>
                                                <img src={marker_icon} alt="" />
                                            </span>
                                            {e.name}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                </div>
                <div className="form-group nex-action-flex">
                    <Button
                        id="nex-pa-about-submit-btn"
                        className="nex-btn-primary mr-2"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        id="nex-pa-about-cancel-btn"
                        onClick={() => setModal(false)}
                        className="nex-btn-primary-outline"
                        color="primary"
                    >
                        Cancel
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default JobHospitalEditModalForPractitionerUser;